@if(isParticipantFlow && timesheets && timesheets.length > 0) {
<ppl-accordion [title]="'Timesheets Waiting For Approval'" [isOpen]="true">
    <ul class="todo-list">
        @for(timesheet of timesheets; track $index) {
        <li class="todo-item">
            <span class="todo-item-title">Timesheet pending for <strong>{{timesheet.providerName}}</strong>
                <strong>({{timesheet.providerPplId}})</strong> for pay period ({{timesheet.payrollStartDate}} -
                {{timesheet.payrollEndDate}})</span>
            <span class="todo-status">Pending</span>
        </li>
        }
    </ul>
</ppl-accordion>
}

<ppl-accordion [title]="'To Do List'" [isOpen]="true">
    @if((checkListData && checkListData.length > 0) || (paceConsumers && paceConsumers.length > 0 && isPACE)){
        @if(checkListData && checkListData.length > 0) {
            <ul class="todo-list">
                @for(checkList of checkListData; track $index) {
                <li class="todo-item">
                    <span class="todo-item-title">Checklist <strong>{{checkList.name}}</strong> for
                        <strong>{{checkList.for}}</strong></span>
                    <span class="todo-status">Pending</span>
                </li>
                }

                @for(checkList of prvdrAssociations; track $index) {
                <li class="todo-item">
                    @if(isPA) {
                    <span class="todo-item-title">Offer Letter for {{checkList.providerTypeLabel}}
                        {{checkList.participantFirstName}} {{checkList.participantLastName}}
                        <strong>({{checkList.participantPplId}})</strong></span>
                    } @else {
                    <span class="todo-item-title">Checklist for {{checkList.providerTypeLabel}}
                        {{checkList.participantFirstName}} {{checkList.participantLastName}}
                        <strong>({{checkList.participantPplId}})</strong></span>
                    }
                    <span class="todo-status">Pending</span>
                </li>
                }
            </ul>
    }
    @if (isPA && isPACE && uniqueMcoNames?.length > 0) {
        <ul class="todo-list">
          @for (mco of uniqueMcoNames; track $index) {
            <li class="todo-item">
              <span class="todo-item-title">PACE Criminal Background Check for <strong>{{ mco }}</strong></span>
              <span class="todo-status">Pending</span>
            </li>
          }
        </ul>
    }
}
    @else {
    <nz-alert class="mb-2" nzType="info" nzMessage="No pending items for you." nzShowIcon></nz-alert>
    }
</ppl-accordion>

@if (isProviderFlow) {
<ppl-health-assessment-list [programCode]="program.program_code" />
}